import { LoadableAccessRestrictionStamp } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function AccessRestrictionStampPage() {
  return (
    <>
      <Breadcrumb />
      <LoadableAccessRestrictionStamp />
    </>
  );
}
